function get_fullpage_instance(component_instance) {
  let parent = component_instance.$parent;

  if (!parent) {
    return null;
  }

  if (parent.$options._componentTag === "full-page") {
    try {
      return parent;
    } catch (e) {
      return null;
    }
  } else {
    return get_fullpage_instance(parent);
  }
}

export default {
  data: () => ({
    fullpage_ref: null
  }),

  methods: {
    moveSectionUp() {
      this.fullpage_ref.api.moveSectionUp();
    },

    moveSectionDown() {
      this.fullpage_ref.api.moveSectionDown();
    },

    moveTo(section, slide) {
      this.fullpage_ref.api.moveTo(section, slide);
    },

    silentMoveTo(section, slide) {
      this.fullpage_ref.api.silentMoveTo(section, slide);
    },

    moveSlideRight() {
      this.fullpage_ref.api.moveSlideRight();
    },

    moveSlideLeft() {
      this.fullpage_ref.api.moveSlideLeft();
    },

    reBuild() {
      this.fullpage_ref.api.reBuild();
    }
  },

  mounted() {
    this.fullpage_ref = get_fullpage_instance(this);
  }
};
